/** Minimal cell shape the grid selection snapshot can supply. */
export interface SecurityFieldCell {
  columnId?: string | number | null;
  columnRef?: string;
  alias?: string;
}

/** A grid cell as the selection hook hands it over: a field cell, or any other cell it can still tell apart. */
export type IdentifiableCell = SecurityFieldCell & { key?: string | number; totalKey?: string };

/**
 * Security field id for a cell, or null when the cell is not addressable.
 * Unsaved columns all carry id 0, so they are told apart by their column ref instead.
 */
export const securityFieldIdOfCell = ({ columnId, columnRef, alias }: SecurityFieldCell): string | null => {
  if (!alias) {
    return null;
  }
  const securityId = Number(columnId);
  if (securityId > 0) {
    return `${securityId}:${alias}`;
  }
  return columnRef ? `ref:${columnRef}:${alias}` : null;
};

/**
 * Stable identity for a Cap Table grid cell, unique across the whole sheet, so a
 * selection survives the grid rebuilding or re-sorting its rows.
 * Cells that carry neither a security field nor a key get no identity, so the grid
 * leaves them out of a selection rather than folding them into another cell.
 */
export const capTableCellIdentity = (cell: IdentifiableCell): string =>
  securityFieldIdOfCell(cell) ?? cell.totalKey ?? (cell.key != null ? String(cell.key) : '');
